import { useState } from "react";
import { Col } from "reactstrap";
import { Btn } from "../../../../../AbstractElements";
import { ClickOut } from "../../../../../Constants/Constants";
import CommonBerlinModalTitle from "../Common/CommonBerlinModalTitle";
import CustomModal3Body from "./CustomModal3Body";

const CustomModal3 = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  return (
    <Col xl="4" md="6" className="custom-alert text-center">
      <div className="card-wrapper border rounded-3 h-100">
        <div className="aria-demo-img">
          <CommonBerlinModalTitle heading="Modal 3 -" subHeading="Balance Modal" text="Example of aria dashboard balance card." />
          <div className="overflow-hidden balance-modal">
            <Btn color="primary" className="mx-auto mt-3" onClick={toggle}>{ClickOut}</Btn>
          </div>
          <CustomModal3Body modal={modal} toggle={toggle} />
        </div>
      </div>
    </Col>
  );
};
export default CustomModal3